import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#480000",
    "col2n": "#D9D9D9"
}
function PlaInd014({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M385 105V0H0v105h385m-38.05-80.75v.2h-4.2q2.35-.1 4.2-.2z"
                    id="PlaInd014__Symbol_29_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col2n}
                    d="M385 279.2V0H0v279.2h385z"
                    id="PlaInd014__col2n_0_Layer0_0_FILL"
                />
                <path
                    fill="#333"
                    d="M34.85 93.9v-.45h-.05v.4H0V294.9h27.75q16.667-27.675 0-55.35 21.51 4.167 15.2-9.55V96.85l-8.1-2.95m297.8 128.55V61.4H56.4v161.05h118.8v9.05h-20.05q-11.55-.4-17.5 2.25-1.45.65-2.55 1.5-.1.05-.15.1-.235.29-.4.55-.527.963-.1 1.7.15.2.5.45h117.2q.35-.3.5-.65.263-.638 0-1.55-.1-.276-.25-.6-.1-.2-.25-.4-.5-.6-1.25-1.1-3.9-2.7-13.75-2.25h-28.8v-9.05h124.3m17.4-128.1l-8.95 3.25V230q-3.79 20.392 19.75 9.55-22.019 32.813 0 55.35H385V94.35h-34.95z"
                    id="PlaInd014__Layer2_0_FILL"
                />
                <path
                    fill="#FFF"
                    d="M360.85 306.45V239.6q-168.127-2.25-333.1 0v66.85h333.1z"
                    id="PlaInd014__Layer2_1_FILL"
                />
                <path
                    fill="#E0E0E0"
                    d="M41.15 298.4h92.75v-7q-42.25-6.85-86.25 0l-6.5 7m92.75-29.65v-5.3q-42.45-8.1-86.75 0l-6 5.3h92.75m15.9 22.6q-.1.05-.2.05l-2.6 7h94.55l-2.85-7q-.1-.05-.15-.05H149.8m8.55-27.9h-8.7l-2.65 5.3h94.55l-2.65-5.3-18.8.15-.35-.15q-30.7-6.65-61.4.4v-.4M339.1 291.4q-.1-.05-.15-.05h-84.1q-.1 0-.2.05v7h92.3l-7.85-7m7.85-22.65l-7.25-5.3q-42.5-8.35-85.05 0v5.3h92.3z"
                    id="PlaInd014__Layer2_3_FILL"
                />
                <path
                    fill="#C2C2C2"
                    d="M147 298.4l2.6-7h89.1l2.85 7v-21.65H147v21.65m-13.1-34.95V248.6H41.15v20.15l6-5.3h86.75m0 27.95v-14.65H41.15v21.65l6.5-7h86.25m15.75-27.95h8.7v.4l61.4-.4.35.15 18.8-.15 2.65 5.3V248.6H147v20.15l2.65-5.3M339.1 291.4l7.85 7v-21.65h-92.3v14.65h84.45m.6-27.95l7.25 5.3V248.6h-92.3v14.85h85.05m21.15-23.9L341.1 230H208.35v1.5h28.8q9.85-.45 13.75 2.25.75.5 1.25 1.1.15.2.25.4.6 1.3.25 2.15-.15.35-.5.65h-117.2q-.35-.25-.5-.45-.55-.95.5-2.25.05-.05.15-.1 1.1-.85 2.55-1.5 5.95-2.65 17.5-2.25h20.05V230H42.95l-15.2 9.55h333.1z"
                    id="PlaInd014__Layer2_4_FILL"
                />
                <path
                    d="M9.2 197.8L0 195.95v48.7l9.2-1.8q4.3-1.85 7.8-5.35 3.45-3.45 5.25-7.5.789-1.848 1.25-3.85.65-2.8.65-5.9 0-3.03-.65-5.8-.294-1.252-.75-2.45-1.732-4.932-5.75-8.95-3.5-3.5-7.8-5.25m7.8-50.1q-7.079-7.03-17-7.1v48.65q9.921-.07 17-7.1 7.15-7.1 7.15-17.25 0-1.95-.25-3.8-1.15-7.65-6.9-13.4m-7.95-38.4q-3.796-3.796-9.05-4.1v28.1q2.282-.098 4.35-.9 2.55-1 4.7-3.15 4.15-4.15 4.15-10 0-1.3-.2-2.5-.7-4.2-3.95-7.45M369.1 237.5q6.683 6.683 15.9 7.1v-48.65q-9.217.464-15.9 7.1-7.15 7.15-7.15 17.2 0 3.796 1 7.15.012.058 0 .1 1.708 5.589 6.15 10m15.9-96.9q-9.217.464-15.9 7.1-7.15 7.15-7.15 17.2 0 10.15 7.15 17.25 2.312 2.296 4.9 3.85 4.972 2.938 11 3.2v-48.6m0-7.4v-27.9q-4.57.62-7.95 4-4.15 4.15-4.15 9.95 0 5.85 4.15 10 3.38 3.38 7.95 3.95z"
                    id="PlaInd014__Layer1_0_FILL"
                />
                <path
                    fill="#666"
                    d="M3.15 215.65q1.7 1.75 1.7 4.2 0 2.55-1.7 4.25-1.412 1.331-3.15 1.6v2.15q2.578-.32 4.6-2.3 1.75-1.75 2.2-4.1.15-.85.15-1.7 0-3.4-2.35-5.8-1.39-1.361-3.05-1.95-.745-.267-1.55-.4v2.4q1.738.319 3.15 1.65M0 202.5v2.5q5.764.216 9.9 4.4 1.228 1.228 2.1 2.6 2.25 3.487 2.25 7.9 0 5.85-3.9 10.1l-.45.45q-4.136 4.089-9.9 4.3v2.75q6.606-.306 11.4-5.1 1.15-1.15 2.05-2.4 3.05-4.35 3.05-10 0-4.395-1.9-8-1.192-2.342-3.2-4.35-4.794-4.794-11.4-5.15m0-43.9q1.738.328 3.15 1.7.55.6.95 1.25.75 1.3.75 2.95 0 2.55-1.7 4.25-1.412 1.331-3.15 1.6v2.15q2.578-.32 4.6-2.3l.5-.5q1.85-2.2 1.85-5.3 0-2.55-1.35-4.55-.45-.65-1-1.3-2.022-1.936-4.6-2.3v2.35m14.65-1.95q-1.25-2.35-3.25-4.35-4.794-4.794-11.4-5.15v2.5q2.717.109 5.15 1.1 2.6 1.15 4.75 3.3 3 2.95 3.9 6.75.45 1.8.45 3.75 0 6.15-4.35 10.55-4.136 4.089-9.9 4.3v2.75q5.08-.238 9.05-3.1 1.2-.9 2.35-2 5.1-5.15 5.1-12.4 0-4.35-1.85-8m-9.8-37.2q0 2.55-1.7 4.25-1.412 1.331-3.15 1.6v2.15q2.578-.32 4.6-2.3 2.35-2.35 2.35-5.8 0-1.4-.4-2.6-.55-1.8-1.95-3.2-2.022-1.98-4.6-2.35v2.4q1.738.319 3.15 1.65.7.7 1.1 1.5.6 1.2.6 2.7M385 205.1v-2.5q-5.912.662-10.3 5.05-3.437 3.437-4.55 7.85-.55 2.136-.55 4.5 0 4.083 1.6 7.5 1.272 2.65 3.5 4.9 4.388 4.388 10.3 5v-2.75q-5.064-.507-8.8-4.2-1.372-1.388-2.3-2.95-2.05-3.39-2.05-7.6 0-2.33.6-4.4 1.047-3.397 3.75-6.1 3.736-3.78 8.8-4.3m0 9.2v-2.45q-1.929.562-3.5 2.1-.714.729-1.2 1.55-1.15 1.883-1.15 4.25 0 3.45 2.35 5.8 1.382 1.352 3.05 1.95.217.082.45.15v-2.25q-1.105-.41-2.05-1.3-1.7-1.7-1.7-4.25 0-2.45 1.7-4.2.081-.077.15-.15.89-.778 1.9-1.2m-13.15-49.75q0-6.2 4.35-10.5 3.736-3.78 8.8-4.3v-2.5q-5.912.662-10.3 5.05-5.1 5.1-5.1 12.35t5.1 12.4q4.388 4.388 10.3 5v-2.75q-5.064-.507-8.8-4.2-4.35-4.4-4.35-10.55m13.15-5.6v-2.45q-1.929.546-3.5 2.05-2.35 2.45-2.35 5.85 0 3.45 2.35 5.8 1.571 1.538 3.5 2.1v-2.25q-1.105-.41-2.05-1.3-1.7-1.7-1.7-4.25 0-2.45 1.7-4.2.945-.918 2.05-1.35m0-45.05v-2.45q-1.929.562-3.5 2.1-2.35 2.4-2.35 5.8 0 3.45 2.35 5.8 1.571 1.538 3.5 2.1V125q-1.105-.41-2.05-1.3-1.7-1.7-1.7-4.25 0-2.45 1.7-4.2.945-.89 2.05-1.35z"
                    id="PlaInd014__Layer1_1_FILL"
                />
                <path
                    fillOpacity={0.251}
                    d="M158.35 264.25q-1.366.14-3.1.3 32.904-2.8 64.5-1.1l.35.15 18.8-.15-.3-.5V248.6h-88.95v14.85h8.7v.8m-24.45-.8V248.6H47.15v14.85h86.75m0 27.95v-14.65H47.85v14.4l-.2.25h86.25m15.6-14.65l.1 14.65h89.1l-.1-.15v-14.5h-89.1m189.6 14.65v-14.65h-84.45v14.65h84.45m.6-27.95l-.6-.4V248.6h-84.45v14.85h85.05z"
                    id="PlaInd014__Layer1_2_FILL"
                />
                <g id="PlaInd014__Layer2_2_FILL">
                    <path d="M208.35 225.05v-2.6H175.2v2.6h33.15M27.75 294.9v-5.3H0v5.3h27.75m299.35-77.5V65.95H61.75V217.4H327.1m33.75 72.2v5.3H385v-5.3h-24.15z" />
                    <path
                        fill="#1E1E1E"
                        d="M42.95 96.85l-8.1-2.95v141.35l8.1-5.25V96.85m307.1-2.5l-8.95 3.25V230l8.95 4.4V94.35z"
                    />
                </g>
                <g id="PlaInd014__Layer1_3_FILL">
                    <path d="M219.8 295.15h-51.65v3.25h51.65v-3.25m-62.75-42.3q-1.4 2.1 0 3.85h33.85q.1 0 .2-.05 1-.3 1.75-.85.25-.2.5-.45.85-2.35-1.75-2.5H157.05z" />
                    <path
                        fill="#333"
                        d="M168.15 280.05v15.1h51.65v-15.1h-51.65m-3.05-27.2h4.3v-1.25h-4.3v1.25m8.6 0h4.4v-1.25h-4.4v1.25m12.8 0v-1.25h-4v1.25h4m-28.1-1.25v1.25h3.7v-1.25h-3.7z"
                    />
                    <path
                        fill="#063"
                        d="M197.4 249.55l-1.6 3.7 36.35 15.5 1.55-3.7-36.3-15.5z"
                    />
                    <path
                        fill="#600"
                        d="M191.1 256.65q-.1.05-.2.05h-27.05v4h39.5v-4.05H191.1z"
                    />
                    <path fill="#C4AB00" d="M158.35 260.7v4h39.5v-4h-39.5z" />
                    <path
                        fill="#309"
                        d="M154.05 264.7v4.05h39.5v-4.05h-39.5z"
                    />
                </g>
                <g id="PlaInd014__Layer1_3_MEMBER_0_FILL">
                    <path
                        fill="#757575"
                        d="M62.45 264.1h-8.4v3.1h8.4v-3.1m51.45-4.3v-1.9H78.55v1.9h35.35m6.55 4.3h-8.4v3.1h8.4v-3.1z"
                    />
                    <path d="M112.05 264.1h13.15v-12.3H50.5v12.3h61.55m1.85-6.2v1.9H78.55v-1.9h35.35z" />
                </g>
                <g id="PlaInd014__Layer1_3_MEMBER_1_FILL">
                    <path
                        fill="#757575"
                        d="M274.55 295.15h-8.4v1.6h8.4v-1.6m49.6 0v1.6h8.4v-1.6h-8.4z"
                    />
                    <path d="M324.15 295.15h13.15v-12.3h-74.7v12.3h61.55m-41-2.95v-6.7h35.3v6.7h-35.3z" />
                    <path fill="#333" d="M283.15 285.5v6.7h35.3v-6.7h-35.3z" />
                </g>
                <g id="PlaInd014__Layer1_3_MEMBER_2_FILL">
                    <path d="M330.45 267.15v-8.25h-46.1v8.25h46.1m-3.95-2.95q-.45.5-1.1.5-1 0-1.4-.75-.2-.35-.2-.8 0-1.5 1.55-1.5t1.55 1.55q0 .55-.4 1z" />
                    <path
                        fill="#060"
                        d="M325.4 264.7q.65 0 1.1-.5.4-.45.4-1 0-1.55-1.55-1.55t-1.55 1.5q0 .45.2.8.4.75 1.4.75z"
                    />
                </g>
                <g id="PlaInd014__Layer1_3_MEMBER_3_FILL">
                    <path d="M117.05 296.85V279.8H56.9v17.05h60.15m-5.3-14.3v3.55H90.9v-3.55h20.85m-43.9-1.05q2.65 0 2.65 2.7 0 .95-.7 1.75-.75.85-1.9.85-1.7 0-2.4-1.3-.35-1.3-.35-1.35 0-2.65 2.7-2.65z" />
                    <path
                        fill="#00F"
                        d="M70.5 284.2q0-2.7-2.65-2.7-2.7 0-2.7 2.65 0 .05.35 1.35.7 1.3 2.4 1.3 1.15 0 1.9-.85.7-.8.7-1.75z"
                    />
                    <path
                        fill="#060"
                        d="M111.75 286.1v-3.55H90.9v3.55h20.85z"
                    />
                </g>
            </defs>
            <use
                xlinkHref="#PlaInd014__Symbol_29_0_Layer0_0_FILL"
                transform="translate(0 280)"
                id="PlaInd014__col1n"
            />
            <use
                xlinkHref="#PlaInd014__col2n_0_Layer0_0_FILL"
                id="PlaInd014__col2n"
            />
            <use xlinkHref="#PlaInd014__Layer2_0_FILL" />
            <use xlinkHref="#PlaInd014__Layer2_1_FILL" />
            <use xlinkHref="#PlaInd014__Layer2_2_FILL" />
            <use xlinkHref="#PlaInd014__Layer2_3_FILL" />
            <use xlinkHref="#PlaInd014__Layer2_4_FILL" />
            <use xlinkHref="#PlaInd014__Layer1_0_FILL" />
            <use xlinkHref="#PlaInd014__Layer1_1_FILL" />
            <use xlinkHref="#PlaInd014__Layer1_2_FILL" />
            <use xlinkHref="#PlaInd014__Layer1_3_FILL" />
            <use xlinkHref="#PlaInd014__Layer1_3_MEMBER_0_FILL" />
            <use xlinkHref="#PlaInd014__Layer1_3_MEMBER_1_FILL" />
            <use xlinkHref="#PlaInd014__Layer1_3_MEMBER_2_FILL" />
            <use xlinkHref="#PlaInd014__Layer1_3_MEMBER_3_FILL" />
        </g></g>
    )
}
export default PlaInd014
